import { CmsNews } from '@/service';

/**
 * @class @name Content
 * @description Exposes menu store module
 */
export default class News {
	/**
	 * @method @static @get @name namespaced
	 * @description Is this module namespaced?
	 */
	static get namespaced() {
		return true;
	}

	/**
	 * @method @static @get @name state
	 * @description Expose state as an object, compatible with vue stores
	 */
	static get state() {
		return {
			newsList: [],
			total: 0
		};
	}

	/**
	 * @method @static @get @name getters
	 * @description Expose getters as an object, compatible with vue stores
	 */
	static get getters() {
		return {
			news: (state) => state.newsList,
			total: (state) => state.total
		};
	}

	/**
	 * @method @static @get @name mutations
	 * @description Expose mutations as an object, compatible with vue stores
	 */
	static get mutations() {
		return {
			/**
			 * @name setNewsList
			 * @description used to set content on store
			 * @param {Object} state
			 * @param {Object} data
			 */
			setNewsList: (state, data) => {
				state.newsList = data.data;
				state.total = data.total;
			}
		};
	}

	/**
	 * @method @static @get @name actions
	 * @description Expose action as an object, compatible with vue stores
	 */
	static get actions() {
		return {
			/**
			 * @async @name loadNewsList
			 * @param {function} commit
			 * @param {Object} filters - Optional filter parameters
			 */
			async loadNewsList({ commit, rootState }, filters = {}) {
				const domain = rootState.CmsSite.site.name || 'default';
				let payload = {
					limit: filters.limit || 6,
					offset: filters.offset || 0,
					order: { direction: 'desc', property: 'created' },
					where: filters.where || []
				};

				let { data } = await CmsNews.list(payload, domain);
				commit('setNewsList', data);
			},

			/**
			 * @async @name loadNewsItem
			 * @param {function} commit
			 * @param {string} id
			 */
			async loadNewsItem(context, id) {
				return CmsNews.get(id);
			}
		};
	}
}
